import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ReferralCalculatorRoutingModule} from './referral-calculator-routing.module';
import {ReferralCalculatorComponent} from './referral-calculator.component';
import {FormsModule} from '@angular/forms';


@NgModule({
    declarations: [ReferralCalculatorComponent],
    imports: [
        CommonModule,
        ReferralCalculatorRoutingModule,
        FormsModule
    ]
})

export class ReferralCalculatorModule {
}
